<div class="error-message">
  <div class="error-message__container">
    <i class="mif-traffic-cone"></i>
    <p>
      <span>{{ "error-message." + status | Translate }}</span>
      <span
        >{{ "error-message.problem-persists" | Translate }}
        <b (click)="openChat()">{{ "user.chat" | Translate }}</b></span
      >
    </p>
  </div>
</div>
